export const GUIDANCE = {
	TOP_PAGE_NAME: 'eClaim:guidance:rakurakutop',
	TOP_LINK_NAME: 'eClaim:guidance:rakurakutop:給付請求を始める',
	CONDITION_TERMS_PAGE_NAME: 'eClaim:guidance:conditionterms',
	CONDITION_AGREE_LINK_NAME: 'eClaim:guidance:conditionterms:同意して次へ進む',
	CONDITION_CLOSE_LINK_NAME: 'eClaim:guidance:conditionterms:閉じる',
	PRIVACY_POLICY_PAGE_NAME: 'eClaim:guidance:privacypolicy',
	PRIVACY_POLICY_AGREE_LINK_NAME: 'eClaim:guidance:privacypolicy:同意して次へ進む',
	PRIVACY_POLICY_RETURN_LINK_NAME: 'eClaim:guidance:privacypolicy:戻る',
	USAGE_COND_PAGE_NAME: 'eClaim:guidance:conditionsofusage',
	USAGE_COND_AGREED_LINK_NAME: 'eClaim:guidance:conditionsofusage:すべて確認した',
	USAGE_COND_RETURN_LINK_NAME: 'eClaim:guidance:conditionsofusage:戻る',
} as const;

export const AUTHENTICATION = {
	PAGE_NAME: 'eClaim:authentication',
	POSTAL_CODE_SELECT_LINK_NAME: 'eClaim:authentication:郵便番号から住所を選択',
	POSTAL_CODE_SELECT_POPUP_PAGE_NAME: 'eClaim:authenticationpostalCodeselectPopup',
	POSTAL_CODE_SELECT_POPUP_SELECT_LINK_NAME: 'eClaim:authenticationpostalCodeselectPopup:選択',
	NEXT_LINK_NAME: 'eClaim:authentication:次へ',
} as const;

export const DOCUMENT_GUIDANCE = {
	TRANSACTION_NAME: 'documentguidanceQuestion',
	Q1_PAGE_NAME: 'eClaim:documentguidance:q1',
	Q1_NEXT_LINK_NAME: 'eClaim:documentguidance:q1:次へ',
	Q2_PAGE_NAME: 'eClaim:documentguidance:q2',
	Q2_NEXT_LINK_NAME: 'eClaim:documentguidance:q2:次へ',
	Q3_PAGE_NAME: 'eClaim:documentguidance:q3',
	Q3_NEXT_LINK_NAME: 'eClaim:documentguidance:q3:次へ',
	Q3_RESULT_LINK_NAME: 'eClaim:documentguidance:q3:必要書類の判定結果をみる',
	Q4_PAGE_NAME: 'eClaim:documentguidance:q4',
	Q4_NEXT_LINK_NAME: 'eClaim:documentguidance:q4:次へ',
	Q4_RESULT_LINK_NAME: 'eClaim:documentguidance:q4:必要書類の判定結果をみる',
	Q5_PAGE_NAME: 'eClaim:documentguidance:q5',
	Q5_NEXT_LINK_NAME: 'eClaim:documentguidance:q5:次へ',
	Q5_RESULT_LINK_NAME: 'eClaim:documentguidance:q5:必要書類の判定結果をみる',
	RESULT_CONFIRMATION_PAGE_NAME: 'eClaim:documentguidance:confirmation',
	RESULT_CONFIRMATION_FINISH_LINK_NAME: 'eClaim:documentguidance:confirmation:給付金請求を終了する',
	RESULT_CONFIRMATION_RECHECK_LINK_NAME: 'eClaim:documentguidance:confirmation:必要書類を確認しなおす',
	RESULT_NEXT_PAGE_NAME: 'eClaim:documentguidance:next',
	RESULT_NEXT_LINK_NAME: 'eClaim:documentguidance:next:次へ',
} as const;

export const FILE_UPLOAD = {
	PAGE_NAME: 'eClaim:fileupload',

	CAMERA_LINK_NAME: 'eClaim:fileupload:カメラを起動して撮影',
	CAMERA_TRANSACTION_NAME: 'uploadPinputSubmit',

	FOLDER_LINK_NAME: 'eClaim:fileupload:保存したファイルを選択',
	FOLDER_TRANSACTION_NAME: 'uploadSelectFileFromFolderSubmit',

    SUBMIT_DOCUMENT_LINK_NAME: 'eClaim:fileupload:書類を提出する'
} as const;

export const FILE_UPLOAD_ERROR = {

	DOCUMENT_MISMATCH_PAGE_NAME: 'eClaim:fileupload:warning:documentMismatch',
	DOCUMENT_MISMATCH_REUPLOAD_LINK_NAME: 'eClaim:fileupload:warning:documentMismatch:アップロードし直す',
	DOCUMENT_MISMATCH_SUBMIT_LINK_NAME: 'eClaim:fileupload:warning:documentMismatch:このまま提出する',
	DOCUMENT_MISMATCH_TRANSACTION_NAME: 'uploadDocumentSubmit',

	UNSUPPORTED_FORMAT_PAGE_NAME: 'eClaim:warning:unSupportedFormat',
	UNSUPPORTED_FORMAT_REUPLOAD_LINK_NAME: 'eClaim:warning:unSupportedFormat:アップロードし直す',
	UNSUPPORTED_FORMAT_TRANSACTION_NAME: 'uploadUnsupportedFormatSubmit',

	FILE_SIZE_EXCEEDED_PAGE_NAME: 'eClaim:warning:fileSizeOver',
	FILE_SIZE_EXCEEDED_REUPLOAD_LINK_NAME: 'eClaim:warning:fileSizeOver:アップロードし直す',
	FILE_SIZE_EXCEEDED_TRANSACTION_NAME: 'uploadFileSizeExceededSubmit',

	FILE_NUMBER_EXCEEDED_PAGE_NAME: 'eClaim:warning:filePagesOver',
	FILE_NUMBER_EXCEEDED_REUPLOAD_LINK_NAME: 'eClaim:warning:filePagesOver:アップロードし直す',
	FILE_NUMBER_EXCEEDED_TRANSACTION_NAME: 'uploadFileNumberExceededSubmit',

	VIRUS_SCAN_PAGE_NAME: 'eClaim:warning:virusScanerror',
	VIRUS_SCAN_REUPLOAD_LINK_NAME: 'eClaim:warning:virusScanerror:アップロードし直す',
	VIRUS_SCAN_TRANSACTION_NAME: 'uploadVirusScanSubmit',

	BLOB_FAILURE_PAGE_NAME: 'eClaim:warning:blobStorageFailure',
	BLOB_FAILURE_REUPLOAD_LINK_NAME: 'eClaim:warning:blobStorageFailure:アップロードし直す',
	BLOB_FAILURE_TRANSACTION_NAME: 'uploadBlobFailureSubmit',

	NETWORK_ISSUE_PAGE_NAME: 'eClaim:warning:networkIssue',
	NETWORK_ISSUE_REUPLOAD_LINK_NAME: 'eClaim:warning:networkIssue:アップロードし直す',
	NETWORK_ISSUE_TRANSACTION_NAME: 'uploadNetworkIssueSubmit',

	MULTIPLE_IMAGES_PDF_PAGE_NAME: 'eClaim:warning:multipleImagePDF',
	MULTIPLE_IMAGES_PDF_REUPLOAD_LINK_NAME: 'eClaim:warning:multipleImagePDF:アップロードし直す',
	MULTIPLE_IMAGES_PDF_SUBMIT_LINK_NAME: 'eClaim:warning:multipleImagePDF:このまま提出する',
	MULTIPLE_IMAGES_PDF_TRANSACTION_NAME: 'uploadMultipleImagesPDFSubmit',
    
	MULTIPLE_IMAGES_IMAGE_PAGE_NAME: 'eClaim:warning:multipleImageImage',
	MULTIPLE_IMAGES_IMAGE_REUPLOAD_LINK_NAME: 'eClaim:warning:multipleImageImage:アップロードし直す',
	MULTIPLE_IMAGES_IMAGE_SUBMIT_LINK_NAME: 'eClaim:warning:multipleImageImage:このまま提出する',
	MULTIPLE_IMAGES_IMAGE_TRANSACTION_NAME: 'uploadMultipleImagesSubmit',

	ENCRYPTED_PAGE_NAME: 'eClaim:warning:encryptedError',
	ENCRYPTED_REUPLOAD_LINK_NAME: 'eClaim:warning:encryptedError:アップロードし直す',
	ENCRYPTED_TRANSACTION_NAME: 'uploadEncryptSubmit',
} as const;

export const CLAIM_QUESTIONS = {
	DISEASE_OR_INJURY_PAGE_NAME: 'eClaim:claimquestion:diseaseOrInjury',
	DISEASE_OR_INJURY_NEXT_LINK_NAME: 'eClaim:claimquestion:diseaseOrInjury:次へ',

	DISEASE_NAME_PAGE_NAME: 'eClaim:claimquestion:diseaseName',
	DISEASE_NAME_NEXT_LINK_NAME: 'eClaim:claimquestion:diseaseName:次へ',

	DISEASE_BODYPARTS_PAGE_NAME: 'eClaim:claimquestion:diseaseBodyparts',
	DISEASE_BODYPARTS_NEXT_LINK_NAME: 'eClaim:claimquestion:diseaseBodyparts:次へ',

	TRAFFIC_ACCIDENT_PAGE_NAME: 'eClaim:claimquestion:trafficAccident',
	TRAFFIC_ACCIDENT_NEXT_LINK_NAME: 'eClaim:claimquestion:trafficAccident:次へ',

	CLAIM_INCIDENT_DATE_PAGE_NAME: 'eClaim:claimquestion:claimIncidentDate',
	CLAIM_INCIDENT_DATE_NEXT_LINK_NAME: 'eClaim:claimquestion:claimIncidentDate:次へ',

	INJURY_NAME_PAGE_NAME: 'eClaim:claimquestion:injuryName',
	INJURY_NAME_NEXT_LINK_NAME: 'eClaim:claimquestion:injuryName:次へ',

	INJURY_BODYPARTS_PAGE_NAME: 'eClaim:claimquestion:injuryBodyparts',
	INJURY_BODYPARTS_NEXT_LINK_NAME: 'eClaim:claimquestion:injuryBodyparts:次へ',

	HAS_SURGERY_PAGE_NAME: 'eClaim:claimquestion:hasSurgery',
	HAS_SURGERY_NEXT_LINK_NAME: 'eClaim:claimquestion:hasSurgery:次へ',

	SURGERY_DATE_PAGE_NAME: 'eClaim:claimquestion:surgeryDate',
	SURGERY_DATE_NEXT_LINK_NAME: 'eClaim:claimquestion:surgeryDate:次へ',

	SURGERY_TYPE_PAGE_NAME: 'eClaim:claimquestion:surgeryType',
	SURGERY_TYPE_NEXT_LINK_NAME: 'eClaim:claimquestion:surgeryType:次へ',

	SURGERY_PERFORMED_ON_FINGER_OR_TOE_PAGE_NAME: 'eClaim:claimquestion:surgeryPerformedOnFingerOrToe',
	SURGERY_PERFORMED_ON_FINGER_OR_TOE_NEXT_LINK_NAME: 'eClaim:claimquestion:surgeryPerformedOnFingerOrToe:次へ',

	EXACT_SURGICAL_SITE_PAGE_NAME: 'eClaim:claimquestion:exactSurgicalSite',
	EXACT_SURGICAL_SITE_NEXT_LINK_NAME: 'eClaim:claimquestion:exactSurgicalSite:次へ',

	CLAIM_QUESTION_CONFIRMATION_PAGE_NAME: 'eClaim:claimquestion:claimuestionConfirmation',
	CLAIM_QUESTION_CONFIRMATION_SUBMIT_LINK_NAME: 'eClaim:claimquestion:claimuestionConfirmation:請求する',
} as const;

export const INPUT_FORM = {
	BANK_SELECT_PAGE_NAME: 'eClaim:inputForm:Bankselect',
	BANK_SELECT_SELECT_LINK_NAME: 'eClaim:inputForm:Bankselect:金融機関と支店を選択',

	BANK_SELECT_POPUP_PAGE_NAME: 'eClaim:inputForm:BankselectPopup',
	BANK_SELECT_POPUP_SEARCH_LINK_NAME: 'eClaim:inputForm:BankselectPopup:検索',
	BANK_SELECT_POPUP_SELECT_LINK_NAME: 'eClaim:inputForm:BankselectPopup:選択',

	BRANCH_SELECT_POPUP_PAGE_NAME: 'eClaim:inputForm:BranchselectPopup',
	BRANCH_SELECT_POPUP_SEARCH_LINK_NAME: 'eClaim:inputForm:BranchselectPopup:検索',
	BRANCH_SELECT_POPUP_SELECT_LINK_NAME: 'eClaim:inputForm:BranchselectPopup:選択',

	BANK_ACCOUNT_NUMBER_PAGE_NAME: 'eClaim:inputForm:bankAccountNumber',
	BANK_ACCOUNT_NUMBER_NEXT_LINK_NAME: 'eClaim:inputForm:bankAccountNumber:次へ',

	BANK_ACCOUNT_CONFIRMATION_PAGE_NAME: 'eClaim:inputForm:bankAccountConfirmation',
	BANK_ACCOUNT_CONFIRMATION_NEXT_LINK_NAME: 'eClaim:inputForm:bankAccountConfirmation:次へ',
	BANK_ACCOUNT_CONFIRMATION_SUBMIT_LINK_NAME: 'eClaim:inputForm:bankAccountConfirmation:請求する',

	POSTAL_CODE_SELECT_PAGE_NAME: 'eClaim:inputform:postalCodeselect',
	POSTAL_CODE_SELECT_SEARCH_LINK_NAME: 'eClaim:inputform:postalCodeselect:郵便番号から住所を検索',

	POSTAL_CODE_SELECT_POPUP_PAGE_NAME: 'eClaim:inputform:postalCodeselectPopup',
	POSTAL_CODE_SELECT_POPUP_SELECT_LINK_NAME: 'eClaim:inputform:postalCodeselectPopup:選択',

	ADDITIONAL_ADDRESS_INPUT_PAGE_NAME: 'eClaim:inputform:additionalAddressinput',
	ADDITIONAL_ADDRESS_INPUT_NEXT_LINK_NAME: 'eClaim:inputform:additionalAddressinput:次へ',

	ADDRESS_CONFIRMATION_PAGE_NAME: 'eClaim:inputform:addressConfirmation',
	ADDRESS_CONFIRMATION_SUBMIT_LINK_NAME: 'eClaim:inputform:addressConfirmation:請求する',
} as const;

export const CLAIM_COMPLETE = {
	CLAIM_CONFIRMATION_PAGE_NAME: 'eClaim:claimComplete:claimConfirmation',
} as const;



export * as EclaimsAdobeTags from './eclaims-adobe-tags';